import { useEffect } from 'react';
import { create } from 'zustand';
import { meApi } from '@/api/endpoints';
import type { CourseAccessResponse } from '@/api/types';
import { useAuthStore } from '@/store/auth';

interface AccessState {
  /** Qaysi foydalanuvchi uchun yuklangan (boshqa foydalanuvchiga o'tsa qayta yuklanadi) */
  userId: number | null;
  data: CourseAccessResponse | null;
  loading: boolean;
  load: (userId: number) => void;
  reset: () => void;
}

const useAccessStore = create<AccessState>((set, get) => ({
  userId: null,
  data: null,
  loading: false,
  load: (userId) => {
    const s = get();
    if (s.userId === userId && (s.data || s.loading)) return;
    set({ userId, data: null, loading: true });
    meApi
      .courseAccess()
      .then((res) => {
        if (get().userId === userId) set({ data: res.data, loading: false });
      })
      .catch(() => {
        if (get().userId === userId) set({ loading: false });
      });
  },
  reset: () => set({ userId: null, data: null, loading: false }),
}));

/**
 * Sotib olingan kurs va kasblar (kasb ichidagi kurslar ham). Shaxsiy ma'lumot — prerender
 * HTML da yo'q, hydration'dan keyin yuklanadi; anonimda hamma narsa "sotib olinmagan".
 * Premium obuna kurslarni ochmaydi — faqat xarid yoki ADMIN.
 */
export function useCourseAccess() {
  const userId = useAuthStore((s) => s.user?.id);
  const { data, load, reset } = useAccessStore();

  useEffect(() => {
    if (userId === undefined) reset();
    else load(userId);
  }, [userId, load, reset]);

  const all = data?.all ?? false;
  return {
    hasCourse: (slug: string) => all || (data?.courses.includes(slug) ?? false),
    hasCareer: (slug: string) => all || (data?.careers.includes(slug) ?? false),
  };
}
